var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.1665H6.66671M8.33337 12.4998H6.66671M13.3334 5.83317H6.66671M16.6667 5.6665V14.3332C16.6667 15.7333 16.6667 16.4334 16.3942 16.9681C16.1545 17.4386 15.7721 17.821 15.3017 18.0607C14.7669 18.3332 14.0668 18.3332 12.6667 18.3332H7.33337C5.93324 18.3332 5.23318 18.3332 4.6984 18.0607C4.22799 17.821 3.84554 17.4386 3.60586 16.9681C3.33337 16.4334 3.33337 15.7333 3.33337 14.3332V5.6665C3.33337 4.26637 3.33337 3.56631 3.60586 3.03153C3.84554 2.56112 4.22799 2.17867 4.6984 1.93899C5.23318 1.6665 5.93324 1.6665 7.33337 1.6665H12.6667C14.0668 1.6665 14.7669 1.6665 15.3017 1.93899C15.7721 2.17867 16.1545 2.56112 16.3942 3.03153C16.6667 3.56631 16.6667 4.26637 16.6667 5.6665Z",
    stroke: "#2D4C5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFile;